import React from "react"

function PrivacyPolicy() {
    return (
        <div className="prose max-w-2xl mx-auto py-8 px-8 sm:px-0">
            <h1 className="mb-4">PRIVACY POLICY / POLITIKA ZASEBNOSTI</h1>
            
            <h2>1. GENERAL INFORMATION / SPLOŠNE INFORMACIJE</h2>
            <p className="mb-6">
                This Privacy Policy explains how eduardbelskiy.com (hereinafter: "we", "our", "the Website") collects, uses, stores, and protects your personal data in accordance with the General Data Protection Regulation (GDPR).<br />
                Ta politika zasebnosti pojasnjuje, kako eduardbelskiy.com (v nadaljevanju: "mi", "naša spletna stran") zbira, uporablja, shranjuje in varuje vaše osebne podatke v skladu z Uredbo GDPR.
            </p>
            
            <h2>2. DATA CONTROLLER / UPRAVLJALEC PODATKOV</h2>
            <p className="mb-6">
                The data controller is:<br />
                Eduard Belskiy Art<br />
                Location: Slovenia<br />
                Email: info@eduardbelsky.com<br />
                Upravljalec podatkov je:<br />
                Eduard Belskiy Art<br />
                Lokacija: Slovenija<br />
                E-pošta: info@eduardbelsky.com
            </p>
            
            <h2>3. PERSONAL DATA WE COLLECT / OSEBNI PODATKI, KI JIH ZBIRAMO</h2>
            <p className="mb-6">
                We collect the following personal data when you place an order or contact us:<br />
                - Full name<br />
                - Shipping and billing address<br />
                - Email address<br />
                - Phone number<br />
                - Payment details (processed securely via third-party payment providers)<br />
                Zbiramo naslednje osebne podatke, ko oddate naročilo ali nas kontaktirate:<br />
                - Polno ime<br />
                - Naslov za dostavo in račun<br />
                - E-poštni naslov<br />
                - Telefonska številka<br />
                - Podatki o plačilu (varno obdelani prek ponudnikov plačilnih storitev)
            </p>
            
            <h2>4. PURPOSE OF DATA PROCESSING / NAMEN OBDELAVE PODATKOV</h2>
            <p className="mb-6">
                Your personal data is processed only for the following purposes:<br />
                - To process and deliver your order<br />
                - To communicate with you about your order<br />
                - To comply with legal obligations<br />
                Vaši osebni podatki se obdelujejo izključno za naslednje namene:<br />
                - Za obdelavo in dostavo vašega naročila<br />
                - Za komunikacijo v zvezi z vašim naročilom<br />
                - Za izpolnjevanje zakonskih obveznosti
            </p>
            
            <h2>5. LEGAL BASIS / PRAVNA PODLAGA</h2>
            <p className="mb-6">
                We process your data based on:<br />
                - Contractual necessity (processing your order)<br />
                - Legal obligation (invoicing, record-keeping)<br />
                - Consent (if you subscribe to a newsletter)<br />
                Vaše podatke obdelujemo na podlagi:<br />
                - Pogodbene nujnosti (obdelava naročila)<br />
                - Zakonske obveznosti (izdajanje računov, vodenje evidenc)<br />
                - Privolitve (če se prijavite na e-novice)
            </p>
            
            <h2>6. DATA SHARING / POSREDOVANJE PODATKOV</h2>
            <p className="mb-6">
                Your personal data may be shared with:<br />
                - Shipping companies<br />
                - Payment service providers<br />
                - Accounting and legal service providers<br />
                Vaši osebni podatki se lahko posredujejo:<br />
                - Dostavnim službam<br />
                - Ponudnikom plačilnih storitev<br />
                - Računovodskim in pravnim službam
            </p>
            
            <h2>7. DATA RETENTION / HRAMBA PODATKOV</h2>
            <p className="mb-6">
                We retain your personal data only as long as necessary to fulfill the purposes for which it was collected or as required by law.<br />
                Vaše osebne podatke hranimo le toliko časa, kolikor je potrebno za izpolnitev namenov, za katere so bili zbrani, ali kot to zahteva zakon.
            </p>
            
            <h2>8. YOUR RIGHTS / VAŠE PRAVICE</h2>
            <p className="mb-6">
                You have the right to:<br />
                - Access your personal data<br />
                - Request rectification or deletion<br />
                - Object to processing<br />
                - Withdraw consent<br />
                - File a complaint with the supervisory authority (Informacijski pooblaščenec)<br />
                Imate pravico do:<br />
                - Dostopa do svojih osebnih podatkov<br />
                - Popravka ali izbrisa<br />
                - Ugovora obdelavi<br />
                - Preklica privolitve<br />
                - Pritožbe pri nadzornem organu (Informacijski pooblaščenec)
            </p>
            
            <h2>9. COOKIES / PIŠKOTKI</h2>
            <p className="mb-6">
                Our website uses cookies to ensure functionality and improve your experience. You can adjust your preferences via your browser settings.<br />
                Naša spletna stran uporablja piškotke za zagotavljanje funkcionalnosti in izboljšanje uporabniške izkušnje. Nastavitve lahko prilagodite v svojem brskalniku.
            </p>
            
            <h2>10. CONTACT / KONTAKT</h2>
            <p className="mb-6">
                For all questions related to your personal data, please contact:<br />
                info@eduardbelsky.com<br />
                Za vsa vprašanja v zvezi z vašimi osebnimi podatki nas kontaktirajte na:<br />
                info@eduardbelsky.com
            </p>
        </div>
    )
}

export default PrivacyPolicy